export default [
	{
		path: '/',
		name: '/',
		component: () => import( /* webpackChunkName: "map" */ '@/views/home/index')
	},
	// {
	// 	path: "/logins",
	// 	name: 'logins',
	// 	component: () => import( /* webpackChunkName: "map" */ '@/views/home/login')
	// },
	{
		path: "*", // 此处需特别注意置于最底部
		redirect: "/logine"
	}
]